import {
  NodePreloadRulePayload,
  PreloaderRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { NodeType } from 'common/builder/constants/NodeType'
import { INode } from 'common/builder/nodes/nodeInterfaces'
import * as customEventActions from 'common/events/actions/customEventActions'
import { PermissionTargets } from 'common/userRoles'

/**
 * Loads custom events data for action group node when user has permissions.
 */
export const ActionGroupCustomEventsNodeGenericPreloaderRule: PreloaderRule<
  INode,
  NodePreloadRulePayload
> = {
  predicate: (entity: INode, { permissions }) =>
    entity?.nodeType === NodeType.ACTION_GROUP &&
    Boolean(permissions[PermissionTargets.CUSTOM_EVENTS_INTERACTIONS]),

  getKey: () => 'action_group_custom_events_data',

  createLoader:
    (_, { dispatch }) =>
    () => {
      const result = dispatch(customEventActions.fetchCustomEvents())

      /**
       * If custom events are loaded - dispatched action will return undefined.
       * That's why we need to add this check
       */
      if (result instanceof Promise) {
        return result.then(() => true).catch(() => false)
      }

      return Promise.resolve(true)
    },
}
